import {IndustryRoleMapping} from '../types';
import {EnforcedLanguageSetting} from '~/App/context';

export const noOfEmployees = [
  {
    label: '1-9',
    value: '1-9',
  },
  {
    label: '10-19',
    value: '10-19',
  },
  {
    label: '20-29',
    value: '20-29',
  },
  {
    label: '30-39',
    value: '30-39',
  },
  {
    label: '40-49',
    value: '40-49',
  },
  {
    label: '50-99',
    value: '50-99',
  },
  {
    label: '100-249',
    value: '100-249',
  },
  {
    label: '250+',
    value: '250+',
  },
];

export const SUPPORTED_LANGUAGES = [
  'en',
  'da',
  'sv',
  'no',
  'de',
  'fr',
  'it',
  'es',
];

export const langToLocaleDict: Record<
  (typeof SUPPORTED_LANGUAGES)[number],
  EnforcedLanguageSetting
> = {
  en: 'en-GB',
  da: 'da-DK',
  sv: 'sv-SE',
  no: 'nb-NO',
  de: 'de-DE',
  fr: 'fr-FR',
  it: 'it-IT',
  es: 'es-ES',
};

export const TRACKING_QUERY_PARAMS = [
  'gclid',
  'fbclid',
  'gaid',
  'utm_campaign',
  'utm_source',
  'utm_medium',
  'entryReferrerUrl',
];

/**
 * 
    "Czech": 14,
    "Danish": 1,
    "German": 6,
    "Greek": 15,
    "English": 2,
    "Spanish": 11,
    "Finnish": 16,
    "French": 9,
    "Italian": 10,
    "Japanese": 17,
    "Dutch": 12,
    "Norwegian": 4,
    "Polish": 8,
    "Swedish": 5,
    "Thai": 22,
    "English_UK": 19,
    "Portuguese": 13,
    "Chinese_SG": 21
 */

export const ENGLISH_UK_LANGUAGE_ID = 19;

export const MOBILE_BREAKPOINT = 480;

export const TABLET_BREAKPOINT = 1023;

export const INDUSTRIES = {
  hospitality: {
    value: 'Hospitality',
    label: {
      term: 'SignUp.Industry_Hospitality',
      fallback: 'Hospitality',
    },
  },
  retail: {
    value: 'Retail',
    label: {
      term: 'SignUp.Industry_Retail',
      fallback: 'Retail',
    },
  },
  professionalServices: {
    value: 'Professional Services',
    label: {
      term: 'SignUp.Industry_ProfessionalServices',
      fallback: 'Professional Services',
    },
  },
  entertainmentAndLeisure: {
    value: 'Entertainment & Leisure',
    label: {
      term: 'SignUp.Industry_EntertainmentLeisure',
      fallback: 'Entertainment & Leisure',
    },
  },
  healthcareAndMedical: {
    value: 'Healthcare & Medical',
    label: {
      term: 'SignUp.Industry_HealthcareMedical',
      fallback: 'Healthcare & Medical',
    },
  },
  wellnessAndFitness: {
    value: 'Wellness & Fitness',
    label: {
      term: 'SignUp.Industry_WellnessFitness',
      fallback: 'Wellness & Fitness',
    },
  },
  education: {
    value: 'Education',
    label: {
      term: 'SignUp.Industry_Education',
      fallback: 'Education',
    },
  },
  finance: {
    value: 'Finance',
    label: {
      term: 'SignUp.Industry_Finance',
      fallback: 'Finance',
    },
  },
  mediaAndCommunications: {
    value: 'Media & Communications',
    label: {
      term: 'SignUp.Industry_MediaCommunications',
      fallback: 'Media & Communications',
    },
  },
  transportation: {
    value: 'Transportation',
    label: {
      term: 'SignUp.Industry_Transportation',
      fallback: 'Transportation',
    },
  },
  other: {
    value: 'Other',
    label: {
      term: 'SignUp.Industry_Other',
      fallback: 'Other',
    },
  },
};

export const SUBINDUSTRIES = {
  hotels: {
    value: 'Hotels',
    label: {
      term: 'SignUp.Industry_Hotels',
      fallback: 'Hotels',
    },
  },
  cafeAndRestaurant: {
    value: 'Café & Restaurant',
    label: {
      term: 'SignUp.Industry_CafeRestaurant',
      fallback: 'Café & Restaurant',
    },
  },
  barPubAndNightclub: {
    value: 'Bar, Pub & Nightclub',
    label: {
      term: 'SignUp.Industry_BarPubNightclub',
      fallback: 'Bar, Pub & Nightclub',
    },
  },
  cateringAndCanteen: {
    value: 'Catering & Canteen',
    label: {
      term: 'SignUp.Industry_CateringCanteen',
      fallback: 'Catering & Canteen',
    },
  },
  retailStore: {
    value: 'Retail Store',
    label: {
      term: 'SignUp.Industry_RetailStore',
      fallback: 'Retail Store',
    },
  },
  bakery: {
    value: 'Bakery',
    label: {
      term: 'SignUp.Industry_Bakery',
      fallback: 'Bakery',
    },
  },
  commerce: {
    value: 'Commerce',
    label: {
      term: 'SignUp.Industry_Commerce',
      fallback: 'Commerce',
    },
  },
  barberShopsAndBeautySalons: {
    value: 'Barber Shops & Beauty Salons',
    label: {
      term: 'SignUp.Industry_BarberShopsBeautySalons',
      fallback: 'Barber Shops & Beauty Salons',
    },
  },
  gardenCentres: {
    value: 'Garden Centres',
    label: {
      term: 'SignUp.Industry_GardenCentres',
      fallback: 'Garden Centres',
    },
  },
  realEstate: {
    value: 'Real Estate',
    label: {
      term: 'SignUp.Industry_RealEstate',
      fallback: 'Real Estate',
    },
  },
  cleaningServices: {
    value: 'Cleaning Services',
    label: {
      term: 'SignUp.Industry_CleaningServices',
      fallback: 'Cleaning Services',
    },
  },
  security: {
    value: 'Security',
    label: {
      term: 'SignUp.Industry_Security',
      fallback: 'Security',
    },
  },
  staffingAndRecruiting: {
    value: 'Staffing and Recruiting',
    label: {
      term: 'SignUp.Industry_StaffingAndRecruiting',
      fallback: 'Staffing and Recruiting',
    },
  },
  callCenterAndTelemarketing: {
    value: 'Call Center & Telemarketing',
    label: {
      term: 'SignUp.Industry_CallCenterTelemarketing',
      fallback: 'Call Center & Telemarketing',
    },
  },
  facilitiesManagementAndCommercialCleaning: {
    value: 'Facilities Management & Commercial Cleaning',
    label: {
      term: 'SignUp.Industry_FacilitiesManagementCommercialCleaning',
      fallback: 'Facilities Management & Commercial Cleaning',
    },
  },
  entertainmentCinemasAndFunParks: {
    value: 'Entertainment, Cinemas & Fun Parks',
    label: {
      term: 'SignUp.Industry_EntertainmentCinemasFunParks',
      fallback: 'Entertainment, Cinemas & Fun Parks',
    },
  },
  eventsAndEventManagement: {
    value: 'Events & Event Management',
    label: {
      term: 'SignUp.Industry_EventsEventManagement',
      fallback: 'Events & Event Management',
    },
  },
  museumsAndInstitutions: {
    value: 'Museums and Institutions',
    label: {
      term: 'SignUp.Industry_MuseumsInstitutions',
      fallback: 'Museums and Institutions',
    },
  },
  performingArts: {
    value: 'Performing Arts',
    label: {
      term: 'SignUp.Industry_PerformingArts',
      fallback: 'Performing Arts',
    },
  },
  elderlyCareServices: {
    value: 'Elderly Care Services',
    label: {
      term: 'SignUp.Industry_ElderlyCareServices',
      fallback: 'Elderly Care Services',
    },
  },
  dentalOffices: {
    value: 'Dental Offices',
    label: {
      term: 'SignUp.Industry_DentalOffices',
      fallback: 'Dental Offices',
    },
  },
  hospitalAndHealthcare: {
    value: 'Hospitals and Health Care',
    label: {
      term: 'SignUp.Industry_HospitalHealthcare',
      fallback: 'Hospitals and Health Care',
    },
  },
  drugStoresAndPharmacies: {
    value: 'Drug Stores & Pharmacies',
    label: {
      term: 'SignUp.Industry_DrugStoresPharmacies',
      fallback: 'Drug Stores & Pharmacies',
    },
  },
  veterinary: {
    value: 'Veterinary Services',
    label: {
      term: 'SignUp.Industry_VeterinaryServices',
      fallback: 'Veterinary Services',
    },
  },
  fitnessAndDanceFacilities: {
    value: 'Fitness & Dance Facilities',
    label: {
      term: 'SignUp.Industry_FitnessDanceFacilities',
      fallback: 'Fitness & Dance Facilities',
    },
  },
  sports: {
    value: 'Sports',
    label: {
      term: 'SignUp.Industry_Sports',
      fallback: 'Sports',
    },
  },
  collegesAndUniversities: {
    value: 'Colleges & Universities',
    label: {
      term: 'SignUp.Industry_CollegesUniversities',
      fallback: 'Colleges & Universities',
    },
  },
  primarySecondaryEducation: {
    value: 'Primary/Secondary Education',
    label: {
      term: 'SignUp.Industry_PrimarySecondaryEducation',
      fallback: 'Primary/Secondary Education',
    },
  },
  childcare: {
    value: 'Childcare',
    label: {
      term: 'SignUp.Industry_Childcare',
      fallback: 'Childcare',
    },
  },
  accounting: {
    value: 'Accounting',
    label: {
      term: 'SignUp.Industry_Accounting',
      fallback: 'Accounting',
    },
  },
  insurance: {
    value: 'Insurance',
    label: {
      term: 'SignUp.Industry_Insurance',
      fallback: 'Insurance',
    },
  },
  banking: {
    value: 'Banking',
    label: {
      term: 'SignUp.Industry_Banking',
      fallback: 'Banking',
    },
  },
  advertisingAndMarketing: {
    value: 'Advertising & Marketing',
    label: {
      term: 'SignUp.Industry_AdvertisingAndMarketing',
      fallback: 'Advertising & Marketing',
    },
  },
  media: {
    value: 'Media',
    label: {
      term: 'SignUp.Industry_Media',
      fallback: 'Media',
    },
  },
  press: {
    value: 'Press',
    label: {
      term: 'SignUp.Industry_Press',
      fallback: 'Press',
    },
  },
  logisticsAndSupplyChain: {
    value: 'Logistics and Supply Chain',
    label: {
      term: 'SignUp.Industry_LogisticsAndSupplyChain',
      fallback: 'Logistics and Supply Chain',
    },
  },
  warehousing: {
    value: 'Warehousing',
    label: {
      term: 'SignUp.Industry_Warehousing',
      fallback: 'Warehousing',
    },
  },
  transportation: {
    value: 'Transportation',
    label: {
      term: 'SignUp.Industry_Transportation',
      fallback: 'Transportation',
    },
  },
  software: {
    value: 'Software',
    label: {
      term: 'SignUp.Industry_Software',
      fallback: 'Software',
    },
  },
  manufacturing: {
    value: 'Manufacturing',
    label: {
      term: 'SignUp.Industry_Manufacturing',
      fallback: 'Manufacturing',
    },
  },
  construction: {
    value: 'Construction',
    label: {
      term: 'SignUp.Industry_Construction',
      fallback: 'Construction',
    },
  },
  municipality: {
    value: 'Municipality',
    label: {
      term: 'SignUp.Industry_Municipality',
      fallback: 'Municipality',
    },
  },
  nonProfit: {
    value: 'Non-Profit',
    label: {
      term: 'SignUp.Industry_Nonprofit',
      fallback: 'Nonprofit',
    },
  },
  nonProfitAndCharitableOrganizations: {
    value: 'Non-Profit & Charitable Organizations',
    label: {
      term: 'SignUp.Industry_NonProfitCharitableOrganizations',
      fallback: 'Non-Profit & Charitable Organizations',
    },
  },
  other: {
    value: 'Other',
    label: {
      term: 'SignUp.Industry_Other',
      fallback: 'Other',
    },
  },
};

export const ROLES = {
  manager: {
    value: 'Manager',
    label: {
      term: 'SignUp.Manager',
      fallback: 'Manager',
    },
  },
  receptionist: {
    value: 'Receptionist',
    label: {
      term: 'SignUp.Receptionist',
      fallback: 'Receptionist',
    },
  },
  housekeeper: {
    value: 'Housekeeper',
    label: {
      term: 'SignUp.Housekeeping',
      fallback: 'Housekeeper',
    },
  },
  concierge: {
    value: 'Concierge',
    label: {
      term: 'SignUp.Role_Concierge',
      fallback: 'Concierge',
    },
  },
  waiter: {
    value: 'Waiter',
    label: {
      term: 'SignUp.Waiter',
      fallback: 'Waiter',
    },
  },
  chef: {
    value: 'Chef',
    label: {
      term: 'SignUp.Chef',
      fallback: 'Chef',
    },
  },
  host: {
    value: 'Host',
    label: {
      term: 'SignUp.Role_Host',
      fallback: 'Host',
    },
  },
  bartender: {
    value: 'Bartender',
    label: {
      term: 'SignUp.Bartender',
      fallback: 'Bartender',
    },
  },
  barback: {
    value: 'Barback',
    label: {
      term: 'SignUp.Role_Barback',
      fallback: 'Barback',
    },
  },
  caterer: {
    value: 'Caterer',
    label: {
      term: 'SignUp.Role_Caterer',
      fallback: 'Caterer',
    },
  },
  eventServer: {
    value: 'Event Server',
    label: {
      term: 'SignUp.Role_EventServer',
      fallback: 'Event Server',
    },
  },
  cashier: {
    value: 'Cashier',
    label: {
      term: 'SignUp.Cashier',
      fallback: 'Cashier',
    },
  },
  shopAssistant: {
    value: 'Shop Assistant',
    label: {
      term: 'SignUp.Role_ShopAssistant',
      fallback: 'Shop Assistant',
    },
  },
  baker: {
    value: 'Baker',
    label: {
      term: 'SignUp.Role_Baker',
      fallback: 'Baker',
    },
  },
  pastryChef: {
    value: 'Pastry Chef',
    label: {
      term: 'SignUp.Role_PastryChef',
      fallback: 'Pastry Chef',
    },
  },
  teamLeader: {
    value: 'Team Leader',
    label: {
      term: 'SignUp.Role_TeamLead',
      fallback: 'Team Leader',
    },
  },
  assistant: {
    value: 'Assistant',
    label: {
      term: 'SignUp.Role_Assistant',
      fallback: 'Assistant',
    },
  },
  barber: {
    value: 'Barber',
    label: {
      term: 'SignUp.Role_Barber',
      fallback: 'Barber',
    },
  },
  hairStylist: {
    value: 'Hair Stylist',
    label: {
      term: 'SignUp.Role_HairStylist',
      fallback: 'Hair Stylist',
    },
  },
  realEstateAgent: {
    value: 'Real Estate Agent',
    label: {
      term: 'SignUp.Role_RealEstateAgent',
      fallback: 'Real Estate Agent',
    },
  },
  cleaner: {
    value: 'Cleaner',
    label: {
      term: 'SignUp.Role_Cleaner',
      fallback: 'Cleaner',
    },
  },
  supervisor: {
    value: 'Supervisor',
    label: {
      term: 'SignUp.Role_Supervisor',
      fallback: 'Supervisor',
    },
  },
  securityGuard: {
    value: 'Security Guard',
    label: {
      term: 'SignUp.Role_SecurityGuard',
      fallback: 'Security Guard',
    },
  },
  surveillanceOperator: {
    value: 'Surveillance Operator',
    label: {
      term: 'SignUp.Role_SurveillanceOperator',
      fallback: 'Surveillance Operator',
    },
  },
  recruiter: {
    value: 'Recruiter',
    label: {
      term: 'SignUp.Role_Recruiter',
      fallback: 'Recruiter',
    },
  },
  hrSpecialist: {
    value: 'HR Specialist',
    label: {
      term: 'SignUp.Role_HRSpecialist',
      fallback: 'HR Specialist',
    },
  },
  callAgent: {
    value: 'Call Agent',
    label: {
      term: 'SignUp.Role_CallAgent',
      fallback: 'Call Agent',
    },
  },
  teamLead: {
    value: 'Team Leader',
    label: {
      term: 'SignUp.Role_TeamLead',
      fallback: 'Team Leader',
    },
  },
  qaAnalyst: {
    value: 'QA Analyst',
    label: {
      term: 'SignUp.Role_QAAnalyst',
      fallback: 'QA Analyst',
    },
  },
  janitor: {
    value: 'Janitor',
    label: {
      term: 'SignUp.Role_Janitor',
      fallback: 'Janitor',
    },
  },
  siteCleaner: {
    value: 'Site Cleaner',
    label: {
      term: 'SignUp.Role_SiteCleaner',
      fallback: 'Site Cleaner',
    },
  },
  ticketCashier: {
    value: 'Ticket Cashier',
    label: {
      term: 'SignUp.Role_TicketCashier',
      fallback: 'Ticket Cashier',
    },
  },
  rideOperator: {
    value: 'Ride Operator',
    label: {
      term: 'SignUp.Role_RideOperator',
      fallback: 'Ride Operator',
    },
  },
  entertainmentManager: {
    value: 'Entertainment Manager',
    label: {
      term: 'SignUp.Role_EntertainmentManager',
      fallback: 'Entertainment Manager',
    },
  },
  floorManager: {
    value: 'Floor Manager',
    label: {
      term: 'SignUp.Role_Floormanager',
      fallback: 'Floor Manager',
    },
  },
  eventPlanner: {
    value: 'Event Planner',
    label: {
      term: 'SignUp.Role_EventPlanner',
      fallback: 'Event Planner',
    },
  },
  coordinator: {
    value: 'Coordinator',
    label: {
      term: 'SignUp.Role_Coordinator',
      fallback: 'Coordinator',
    },
  },
  venueManager: {
    value: 'Venue Manager',
    label: {
      term: 'SignUp.Role_VenueManager',
      fallback: 'Venue Manager',
    },
  },
  curator: {
    value: 'Curator',
    label: {
      term: 'SignUp.Role_Curator',
      fallback: 'Curator',
    },
  },
  archivist: {
    value: 'Archivist',
    label: {
      term: 'SignUp.Role_Archivist',
      fallback: 'Archivist',
    },
  },
  museumEducator: {
    value: 'Museum Educator',
    label: {
      term: 'SignUp.Role_MuseumEducator',
      fallback: 'Museum Educator',
    },
  },
  actor: {
    value: 'Actor',
    label: {
      term: 'SignUp.Role_Actor',
      fallback: 'Actor',
    },
  },
  director: {
    value: 'Director',
    label: {
      term: 'SignUp.Role_Director',
      fallback: 'Director',
    },
  },
  caregiver: {
    value: 'Caregiver',
    label: {
      term: 'SignUp.Role_Caregiver',
      fallback: 'Caregiver',
    },
  },
  nurse: {
    value: 'Nurse',
    label: {
      term: 'SignUp.Nurse',
      fallback: 'Nurse',
    },
  },
  activitiesCoordinator: {
    value: 'Activities Coordinator',
    label: {
      term: 'SignUp.Role_ActivitiesCoordinator',
      fallback: 'Activities Coordinator',
    },
  },
  dentist: {
    value: 'Dentist',
    label: {
      term: 'SignUp.Role_Dentist',
      fallback: 'Dentist',
    },
  },
  dentalAssistant: {
    value: 'Dental Assistant',
    label: {
      term: 'SignUp.Role_DentalAssistant',
      fallback: 'Dental Assistant',
    },
  },
  doctor: {
    value: 'Doctor',
    label: {
      term: 'SignUp.Role_Doctor',
      fallback: 'Doctor',
    },
  },
  pharmacist: {
    value: 'Pharmacist',
    label: {
      term: 'SignUp.Role_Pharmacist',
      fallback: 'Pharmacist',
    },
  },
  pharmacyTechnician: {
    value: 'Pharmacy Technician',
    label: {
      term: 'SignUp.Role_PharmacyTechnician',
      fallback: 'Pharmacy Technician',
    },
  },
  veterinarian: {
    value: 'Veterinarian',
    label: {
      term: 'SignUp.Role_Veterinarian',
      fallback: 'Veterinarian',
    },
  },
  veterinaryTechnician: {
    value: 'Veterinary Technician',
    label: {
      term: 'SignUp.Role_VeterinaryTechnician',
      fallback: 'Veterinary Technician',
    },
  },
  instructor: {
    value: 'Instructor',
    label: {
      term: 'SignUp.Role_Instructor',
      fallback: 'Instructor',
    },
  },
  personalTrainer: {
    value: 'Personal Trainer',
    label: {
      term: 'SignUp.Role_PersonalTrainer',
      fallback: 'Personal Trainer',
    },
  },
  danceInstructor: {
    value: 'Dance Instructor',
    label: {
      term: 'SignUp.Role_DanceInstructor',
      fallback: 'Dance Instructor',
    },
  },
  gymManager: {
    value: 'Gym Manager',
    label: {
      term: 'SignUp.Role_GymManager',
      fallback: 'Gym Manager',
    },
  },
  coach: {
    value: 'Coach',
    label: {
      term: 'SignUp.Role_Coach',
      fallback: 'Coach',
    },
  },
  trainer: {
    value: 'Trainer',
    label: {
      term: 'SignUp.Role_Trainer',
      fallback: 'Trainer',
    },
  },
  sportsManager: {
    value: 'Sports Manager',
    label: {
      term: 'SignUp.Role_SportsManager',
      fallback: 'Sports Manager',
    },
  },
  professor: {
    value: 'Professor',
    label: {
      term: 'SignUp.Role_Professor',
      fallback: 'Professor',
    },
  },
  lecturer: {
    value: 'Lecturer',
    label: {
      term: 'SignUp.Role_Lecturer',
      fallback: 'Lecturer',
    },
  },
  departmentAssistant: {
    value: 'Department Assistant',
    label: {
      term: 'SignUp.Role_DepartmentAssistant',
      fallback: 'Department Assistant',
    },
  },
  teacher: {
    value: 'Teacher',
    label: {
      term: 'SignUp.Role_Teacher',
      fallback: 'Teacher',
    },
  },
  teachingAssistant: {
    value: 'Teaching Assistant',
    label: {
      term: 'SignUp.Role_TeachingAssistant',
      fallback: 'Teaching Assistant',
    },
  },
  principal: {
    value: 'Principal',
    label: {
      term: 'SignUp.Role_Principal',
      fallback: 'Principal',
    },
  },
  childcareWorker: {
    value: 'Childcare Worker',
    label: {
      term: 'SignUp.Role_ChildcareWorker',
      fallback: 'Childcare Worker',
    },
  },
  preschoolTeacher: {
    value: 'Preschool Teacher',
    label: {
      term: 'SignUp.Role_PreschoolTeacher',
      fallback: 'Preschool Teacher',
    },
  },
  accountant: {
    value: 'Accountant',
    label: {
      term: 'SignUp.Role_Accountant',
      fallback: 'Accountant',
    },
  },
  auditor: {
    value: 'Auditor',
    label: {
      term: 'SignUp.Role_Auditor',
      fallback: 'Auditor',
    },
  },
  bookkeeper: {
    value: 'Bookkeeper',
    label: {
      term: 'SignUp.Role_Bookkeeper',
      fallback: 'Bookkeeper',
    },
  },
  insuranceAgent: {
    value: 'Insurance Agent',
    label: {
      term: 'SignUp.Role_InsuranceAgent',
      fallback: 'Insurance Agent',
    },
  },
  claimsAdjuster: {
    value: 'Claims Adjuster',
    label: {
      term: 'SignUp.Role_ClaimsAdjuster',
      fallback: 'Claims Adjuster',
    },
  },
  bankTeller: {
    value: 'Bank Teller',
    label: {
      term: 'SignUp.Role_BankTeller',
      fallback: 'Bank Teller',
    },
  },
  loanOfficer: {
    value: 'Loan Officer',
    label: {
      term: 'SignUp.Role_LoanOfficer',
      fallback: 'Loan Officer',
    },
  },
  branchManager: {
    value: 'Branch Manager',
    label: {
      term: 'SignUp.Role_BranchManager',
      fallback: 'Branch Manager',
    },
  },
  copywriter: {
    value: 'Copywriter',
    label: {
      term: 'SignUp.Role_Copywriter',
      fallback: 'Copywriter',
    },
  },
  artDirector: {
    value: 'Art Director',
    label: {
      term: 'SignUp.Role_ArtDirector',
      fallback: 'Art Director',
    },
  },
  accountManager: {
    value: 'Account Manager',
    label: {
      term: 'SignUp.Role_AccountManager',
      fallback: 'Account Manager',
    },
  },
  journalist: {
    value: 'Journalist',
    label: {
      term: 'SignUp.Role_Journalist',
      fallback: 'Journalist',
    },
  },
  editor: {
    value: 'Editor',
    label: {
      term: 'SignUp.Role_Editor',
      fallback: 'Editor',
    },
  },
  mediaPlanner: {
    value: 'Media Planner',
    label: {
      term: 'SignUp.Role_MediaPlanner',
      fallback: 'Media Planner',
    },
  },
  reporter: {
    value: 'Reporter',
    label: {
      term: 'SignUp.Role_Reporter',
      fallback: 'Reporter',
    },
  },
  photojournalist: {
    value: 'Photojournalist',
    label: {
      term: 'SignUp.Role_Photojournalist',
      fallback: 'Photojournalist',
    },
  },
  logisticsCoordinator: {
    value: 'Logistics Coordinator',
    label: {
      term: 'SignUp.Role_LogisticsCoordinator',
      fallback: 'Logistics Coordinator',
    },
  },
  supplyChainManager: {
    value: 'Supply Chain Manager',
    label: {
      term: 'SignUp.Role_SupplyChainManager',
      fallback: 'Supply Chain Manager',
    },
  },
  warehouseWorker: {
    value: 'Warehouse Worker',
    label: {
      term: 'SignUp.Role_WarehouseWorker',
      fallback: 'Warehouse Worker',
    },
  },
  inventoryManager: {
    value: 'Inventory Manager',
    label: {
      term: 'SignUp.Role_InventoryManager',
      fallback: 'Inventory Manager',
    },
  },
  driver: {
    value: 'Driver',
    label: {
      term: 'SignUp.Role_Driver',
      fallback: 'Driver',
    },
  },
  dispatcher: {
    value: 'Dispatcher',
    label: {
      term: 'SignUp.Role_Dispatcher',
      fallback: 'Dispatcher',
    },
  },
  fleetManager: {
    value: 'Fleet Manager',
    label: {
      term: 'SignUp.Role_FleetManager',
      fallback: 'Fleet Manager',
    },
  },
  developer: {
    value: 'Developer',
    label: {
      term: 'SignUp.Role_Developer',
      fallback: 'Developer',
    },
  },
  qaEngineer: {
    value: 'QA Engineer',
    label: {
      term: 'SignUp.Role_QAEngineer',
      fallback: 'QA Engineer',
    },
  },
  productManager: {
    value: 'Product Manager',
    label: {
      term: 'SignUp.Role_ProductManager',
      fallback: 'Product Manager',
    },
  },
  machineOperator: {
    value: 'Machine Operator',
    label: {
      term: 'SignUp.Role_MachineOperator',
      fallback: 'Machine Operator',
    },
  },
  productionSupervisor: {
    value: 'Production Supervisor',
    label: {
      term: 'SignUp.Role_ProductionSupervisor',
      fallback: 'Production Supervisor',
    },
  },
  carpenter: {
    value: 'Carpenter',
    label: {
      term: 'SignUp.Role_Carpenter',
      fallback: 'Carpenter',
    },
  },
  siteManager: {
    value: 'Site Manager',
    label: {
      term: 'SignUp.Role_SiteManager',
      fallback: 'Site Manager',
    },
  },
  laborer: {
    value: 'Laborer',
    label: {
      term: 'SignUp.Role_Laborer',
      fallback: 'Laborer',
    },
  },
  administrativeOfficer: {
    value: 'Administrative Officer',
    label: {
      term: 'SignUp.Role_AdministrativeOfficer',
      fallback: 'Administrative Officer',
    },
  },
  cityPlanner: {
    value: 'City Planner',
    label: {
      term: 'SignUp.Role_CityPlanner',
      fallback: 'City Planner',
    },
  },
  fundraiser: {
    value: 'Fundraiser',
    label: {
      term: 'SignUp.Role_Fundraiser',
      fallback: 'Fundraiser',
    },
  },
  programCoordinator: {
    value: 'Program Coordinator',
    label: {
      term: 'SignUp.Role_ProgramCoordinator',
      fallback: 'Program Coordinator',
    },
  },
  volunteerManager: {
    value: 'Volunteer Manager',
    label: {
      term: 'SignUp.Role_VolunteerManager',
      fallback: 'Volunteer Manager',
    },
  },
};

export const INDUSTRY_TO_ROLES_MAPPING: IndustryRoleMapping = [
  {
    industry: INDUSTRIES.hospitality,
    subIndustries: [
      {
        subIndustry: SUBINDUSTRIES.hotels,
        roles: [ROLES.receptionist, ROLES.housekeeper, ROLES.concierge],
      },
      {
        subIndustry: SUBINDUSTRIES.cafeAndRestaurant,
        roles: [ROLES.waiter, ROLES.chef, ROLES.host],
      },
      {
        subIndustry: SUBINDUSTRIES.barPubAndNightclub,
        roles: [ROLES.bartender, ROLES.barback],
      },
      {
        subIndustry: SUBINDUSTRIES.cateringAndCanteen,
        roles: [ROLES.caterer, ROLES.eventServer],
      },
    ],
  },
  {
    industry: INDUSTRIES.retail,
    subIndustries: [
      {
        subIndustry: SUBINDUSTRIES.retailStore,
        roles: [ROLES.cashier, ROLES.shopAssistant],
      },
      {
        subIndustry: SUBINDUSTRIES.bakery,
        roles: [ROLES.baker, ROLES.pastryChef],
      },
      {
        subIndustry: SUBINDUSTRIES.commerce,
        roles: [ROLES.teamLeader, ROLES.assistant],
      },
      {
        subIndustry: SUBINDUSTRIES.barberShopsAndBeautySalons,
        roles: [ROLES.barber, ROLES.hairStylist],
      },
      {
        subIndustry: SUBINDUSTRIES.gardenCentres,
        roles: [ROLES.teamLeader, ROLES.assistant],
      },
    ],
  },
  {
    industry: INDUSTRIES.professionalServices,
    subIndustries: [
      {
        subIndustry: SUBINDUSTRIES.realEstate,
        roles: [ROLES.realEstateAgent],
      },
      {
        subIndustry: SUBINDUSTRIES.cleaningServices,
        roles: [ROLES.cleaner, ROLES.housekeeper, ROLES.supervisor],
      },
      {
        subIndustry: SUBINDUSTRIES.security,
        roles: [ROLES.securityGuard, ROLES.surveillanceOperator],
      },
      {
        subIndustry: SUBINDUSTRIES.staffingAndRecruiting,
        roles: [ROLES.recruiter, ROLES.hrSpecialist],
      },
      {
        subIndustry: SUBINDUSTRIES.callCenterAndTelemarketing,
        roles: [ROLES.callAgent, ROLES.teamLead, ROLES.qaAnalyst],
      },
      {
        subIndustry: SUBINDUSTRIES.facilitiesManagementAndCommercialCleaning,
        roles: [ROLES.janitor, ROLES.siteCleaner],
      },
    ],
  },
  {
    industry: INDUSTRIES.entertainmentAndLeisure,
    subIndustries: [
      {
        subIndustry: SUBINDUSTRIES.entertainmentCinemasAndFunParks,
        roles: [
          ROLES.ticketCashier,
          ROLES.rideOperator,
          ROLES.entertainmentManager,
          ROLES.floorManager,
        ],
      },
      {
        subIndustry: SUBINDUSTRIES.eventsAndEventManagement,
        roles: [ROLES.eventPlanner, ROLES.coordinator, ROLES.venueManager],
      },
      {
        subIndustry: SUBINDUSTRIES.museumsAndInstitutions,
        roles: [ROLES.curator, ROLES.archivist, ROLES.museumEducator],
      },
      {
        subIndustry: SUBINDUSTRIES.performingArts,
        roles: [ROLES.actor, ROLES.director],
      },
    ],
  },
  {
    industry: INDUSTRIES.healthcareAndMedical,
    subIndustries: [
      {
        subIndustry: SUBINDUSTRIES.elderlyCareServices,
        roles: [ROLES.caregiver, ROLES.nurse, ROLES.activitiesCoordinator],
      },
      {
        subIndustry: SUBINDUSTRIES.dentalOffices,
        roles: [ROLES.dentist, ROLES.dentalAssistant, ROLES.receptionist],
      },
      {
        subIndustry: SUBINDUSTRIES.hospitalAndHealthcare,
        roles: [ROLES.nurse, ROLES.doctor, ROLES.receptionist],
      },
      {
        subIndustry: SUBINDUSTRIES.drugStoresAndPharmacies,
        roles: [ROLES.pharmacist, ROLES.pharmacyTechnician],
      },
      {
        subIndustry: SUBINDUSTRIES.veterinary,
        roles: [ROLES.veterinarian, ROLES.veterinaryTechnician],
      },
    ],
  },
  {
    industry: INDUSTRIES.wellnessAndFitness,
    subIndustries: [
      {
        subIndustry: SUBINDUSTRIES.fitnessAndDanceFacilities,
        roles: [
          ROLES.instructor,
          ROLES.personalTrainer,
          ROLES.danceInstructor,
          ROLES.gymManager,
        ],
      },
      {
        subIndustry: SUBINDUSTRIES.sports,
        roles: [ROLES.coach, ROLES.trainer, ROLES.sportsManager],
      },
    ],
  },
  {
    industry: INDUSTRIES.education,
    subIndustries: [
      {
        subIndustry: SUBINDUSTRIES.collegesAndUniversities,
        roles: [ROLES.professor, ROLES.lecturer, ROLES.departmentAssistant],
      },
      {
        subIndustry: SUBINDUSTRIES.primarySecondaryEducation,
        roles: [ROLES.teacher, ROLES.teachingAssistant, ROLES.principal],
      },
      {
        subIndustry: SUBINDUSTRIES.childcare,
        roles: [ROLES.childcareWorker, ROLES.preschoolTeacher],
      },
    ],
  },
  {
    industry: INDUSTRIES.finance,
    subIndustries: [
      {
        subIndustry: SUBINDUSTRIES.accounting,
        roles: [ROLES.accountant, ROLES.auditor, ROLES.bookkeeper],
      },
      {
        subIndustry: SUBINDUSTRIES.insurance,
        roles: [ROLES.insuranceAgent, ROLES.claimsAdjuster],
      },
      {
        subIndustry: SUBINDUSTRIES.banking,
        roles: [ROLES.bankTeller, ROLES.loanOfficer, ROLES.branchManager],
      },
    ],
  },
  {
    industry: INDUSTRIES.mediaAndCommunications,
    subIndustries: [
      {
        subIndustry: SUBINDUSTRIES.advertisingAndMarketing,
        roles: [ROLES.copywriter, ROLES.artDirector, ROLES.accountManager],
      },
      {
        subIndustry: SUBINDUSTRIES.media,
        roles: [ROLES.journalist, ROLES.editor, ROLES.mediaPlanner],
      },
      {
        subIndustry: SUBINDUSTRIES.press,
        roles: [ROLES.reporter, ROLES.editor, ROLES.photojournalist],
      },
    ],
  },
  {
    industry: INDUSTRIES.transportation,
    subIndustries: [
      {
        subIndustry: SUBINDUSTRIES.logisticsAndSupplyChain,
        roles: [ROLES.logisticsCoordinator, ROLES.supplyChainManager],
      },
      {
        subIndustry: SUBINDUSTRIES.warehousing,
        roles: [ROLES.warehouseWorker, ROLES.inventoryManager],
      },
      {
        subIndustry: SUBINDUSTRIES.transportation,
        roles: [ROLES.driver, ROLES.dispatcher, ROLES.fleetManager],
      },
    ],
  },
  {
    industry: INDUSTRIES.other,
    subIndustries: [
      {
        subIndustry: SUBINDUSTRIES.manufacturing,
        roles: [ROLES.machineOperator, ROLES.productionSupervisor],
      },
      {
        subIndustry: SUBINDUSTRIES.construction,
        roles: [ROLES.carpenter, ROLES.siteManager, ROLES.laborer],
      },
      {
        subIndustry: SUBINDUSTRIES.municipality,
        roles: [ROLES.administrativeOfficer, ROLES.cityPlanner],
      },
      {
        subIndustry: SUBINDUSTRIES.nonProfit,
        roles: [ROLES.teamLeader, ROLES.assistant],
      },
      {
        subIndustry: SUBINDUSTRIES.nonProfitAndCharitableOrganizations,
        roles: [
          ROLES.fundraiser,
          ROLES.programCoordinator,
          ROLES.volunteerManager,
        ],
      },
      {
        subIndustry: SUBINDUSTRIES.software,
        roles: [ROLES.developer, ROLES.qaEngineer, ROLES.productManager],
      },
      {
        subIndustry: SUBINDUSTRIES.other,
        roles: [ROLES.teamLeader, ROLES.assistant],
      },
    ],
  },
];

export const PORTAL_OWNER_EMPLOYEE_KEY =
  'employee-0-0-00000000-0000-0000-0000-000000000000';
